import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion, useAnimation } from "framer-motion";
import { ReactComponent as ShoppingBag } from "../../../icons/cart icon 1.svg";

export default function EmptyOrder() {
  const navigate = useNavigate();
  const controls = useAnimation();

  useEffect(() => {
    controls.start("visible");
  }, [controls]);

  // Animation variants
  const container = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const item = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { 
        type: "spring", 
        damping: 12,
        stiffness: 100
      }
    }
  };

  const icon = {
    hidden: { scale: 0.8, opacity: 0 },
    visible: {
      scale: 1,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 10,
        duration: 0.5
      }
    }
  };

  return (
    <motion.div
      className="flex flex-col items-center justify-center h-[60vh] text-center px-2"
      variants={container}
      initial="hidden"
      animate={controls}
    >
      <motion.div
        variants={icon}
        className="relative mb-6"
        animate={{ y: [0, -10, 0] }}
        transition={{
          repeat: Infinity,
          repeatType: "reverse",
          duration: 2,
          ease: "easeInOut"
        }}
      >
        <ShoppingBag 
          size={80} 
          className="text-primary" 
          fill="#FF7236" 
          stroke="none" 
        />
        <div className="absolute inset-0 bg-[#FF7236] rounded-full opacity-10 blur-md" />
      </motion.div>

      <motion.h2 
        variants={item}
        className="text-3xl font-bold text-text-black mb-3 bg-gradient-to-r from-text-black to-gray-700 bg-clip-text text-transparent"
      >
        No orders yet
      </motion.h2>
      
      <motion.p 
        variants={item}
        className="text-lg text-gray-600 max-w-md mb-6"
      >
        Looks like you haven't placed any orders. Start exploring books and get your first one today!
      </motion.p>

      <motion.button
        variants={item}
        onClick={() => navigate("/explore-books")}
        className="mt-2 px-8 py-3.5 border border-primary rounded-full text-primary font-medium hover:bg-primary hover:text-white transition-all duration-300 relative overflow-hidden group"
        whileHover={{ 
          scale: 1.05,
          boxShadow: "0 10px 20px rgba(255, 114, 54, 0.2)"
        }}
        whileTap={{ scale: 0.95 }}
      >
        <span className="relative z-10">Browse Books</span>
        <span className="absolute inset-0 bg-primary opacity-0 group-hover:opacity-10 transition-opacity duration-300 rounded-full" />
        <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-0 group-hover:opacity-20 w-[50%] -rotate-[30deg] group-hover:animate-shine" />
      </motion.button>
    </motion.div>
  );
}